import { Fragment } from 'react';
import { View } from 'react-native';
import { useTheme } from '@ui-kitten/components';
import { useFormikContext } from 'formik';
import lodashIsEmpty from 'lodash/isEmpty';

import ListItem from '../../../../Components/ListItem';
import {
  formikNames,
  modalType,
} from '../../../../Components/Reservation/constants';
import { ids, styles } from '../../../../Components/Reservation/styles';
import ResponsiveText from '../../../../Components/ResponsiveText';
import modals from '../../../../Components/Sheets/modals';
import { ModalManager } from '../../../../Components/Web/Modal/hooks/useModalManager';
import constants from '../../../../Config/constants';
import themeStyle from '../../../../Theme/styles';

import DisplaySelectedSamples from './DisplaySelectedSamples';
import EditButton from './EditButton';
import Pill from './Pill';

const titleCategory = 's1';

const ReservationLeftColumnContent = ({
  yLocRef,
}: {
  yLocRef?: { [key: string]: any };
}) => {
  const theme = useTheme();
  const { setFieldTouched, setFieldValue, values, errors } = useFormikContext();

  // errors
  const dietaryOrAllergyHasError = !lodashIsEmpty(
    errors[formikNames.DIETARYORALLERGY],
  );
  // values
  const dietaryOrAllergyValue = values[formikNames.DIETARYORALLERGY];
  const celebrationsValue = values[formikNames.CELEBRATIONS];

  const _setDietaryOrAllergyValue = (value: string[]) => {
    setFieldTouched(formikNames.DIETARYORALLERGY);
    setFieldValue(formikNames.DIETARYORALLERGY, value);
  };

  const _toggleDietaryOrCelebration = async (type: modalType) => {
    const commonPayload = {
      type,
      value:
        type === modalType.CELEBRATIONS
          ? celebrationsValue
          : dietaryOrAllergyValue,
    };
    const modalPromise = constants.isWeb
      ? ModalManager.show(modals.DIETARY_OR_CELEBRATION, {
          payload: {
            title:
              type === modalType.CELEBRATIONS
                ? 'Special Occasions'
                : 'Dietary Preference',
            ...commonPayload,
          },
        })
      : modals.show(modals.DIETARY_OR_CELEBRATION, commonPayload);
    const result: { name: string; value: any[] } = await modalPromise;
    if (!lodashIsEmpty(result)) {
      setFieldTouched(result.name);
      setFieldValue(result.name, result.value);
    }
  };

  return (
    <Fragment>
      {/* Dietary box */}
      <View
        dataSet={{ media: ids.detailsBox }}
        style={[
          styles.detailsBox,
          dietaryOrAllergyHasError && {
            borderColor: theme['color-danger-500'],
          },
        ]}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          yLocRef.current[formikNames.DIETARYORALLERGY] = layout.y;
        }}
      >
        <ListItem
          contentContainerStyle={themeStyle.spacingBottom}
          leftIcon={{
            name: 'info',
            color: dietaryOrAllergyHasError
              ? theme['color-danger-500']
              : undefined,
          }}
          title={
            <ResponsiveText category={titleCategory}>
              Dietary Preference
              <ResponsiveText category={titleCategory} status="danger">
                *
              </ResponsiveText>
            </ResponsiveText>
          }
          accessoryRight={
            !lodashIsEmpty(dietaryOrAllergyValue) && (
              <EditButton
                onPress={() =>
                  _toggleDietaryOrCelebration(modalType.DIETARYORALLERGY)
                }
              />
            )
          }
        />
        <View style={themeStyle.spacingBottomMedium}>
          <DisplaySelectedSamples
            EmptyComponent={
              <Pill
                leftIcon={{ name: 'plus', size: 20 }}
                title="Add Dietary Preference"
                onPress={() =>
                  _toggleDietaryOrCelebration(modalType.DIETARYORALLERGY)
                }
              />
            }
            values={dietaryOrAllergyValue}
          />
        </View>
        <Pill
          selected={
            Array.isArray(dietaryOrAllergyValue) &&
            lodashIsEmpty(dietaryOrAllergyValue)
          }
          title="No Allergies for me and my party"
          onPress={() => _setDietaryOrAllergyValue([])}
        />
      </View>
      {/* Celebration box */}
      <View dataSet={{ media: ids.detailsBox }} style={styles.detailsBox}>
        <ListItem
          contentContainerStyle={themeStyle.spacingBottom}
          leftIcon={{ name: 'info' }}
          title={
            <ResponsiveText category={titleCategory}>
              Celebrating anything?
            </ResponsiveText>
          }
          accessoryRight={
            !lodashIsEmpty(celebrationsValue) && (
              <EditButton
                onPress={() =>
                  _toggleDietaryOrCelebration(modalType.CELEBRATIONS)
                }
              />
            )
          }
        />
        <View style={themeStyle.spacingBottomMedium}>
          <DisplaySelectedSamples
            EmptyComponent={
              <Pill
                leftIcon={{ name: 'plus', size: 20 }}
                title="Add Special Occasion"
                onPress={() =>
                  _toggleDietaryOrCelebration(modalType.CELEBRATIONS)
                }
              />
            }
            values={celebrationsValue}
          />
        </View>
      </View>
    </Fragment>
  );
};

export default ReservationLeftColumnContent;
